import { AuditNotificationPatchPayload } from '../src/audit-notifications.model';

export namespace AuditNotificationsActions {
  export class LoadSummary {
    static readonly type = '[Audit Notifications] Load Summary';
  }

  export class Save {
    static readonly type = '[Audit Notifications] Save';
    constructor(public readonly payload: AuditNotificationPatchPayload) {}
  }
}
